import { render, staticRenderFns } from "./StaffStep.vue?vue&type=template&id=24ee1525&scoped=true"
import script from "./StaffStep.vue?vue&type=script&lang=js"
export * from "./StaffStep.vue?vue&type=script&lang=js"
import style0 from "./StaffStep.vue?vue&type=style&index=0&id=24ee1525&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ee1525",
  null
  
)

export default component.exports